import { useCallback, useEffect } from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import Iconify from "../ui-kit/Iconify";
import UserTableRow from "../Layout/UserTableRow";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useDispatch, useSelector} from "react-redux";
import {useRouter} from "../../usefuls/hooks";
import {useSearchParams} from "react-router-dom";
import {getMattersListReq, storeMatterReq} from "../../store/Matters/mattersSlice";


const MattersList = () => {
    const [searchParams] = useSearchParams();
    const {
        data: mattersList,
        total: listLength,
        current_page: currentPage,
        per_page: rowsPerPage
    } = useSelector(state => state.matters.mattersList) || {}
    const dispatch = useDispatch();
    const router = useRouter();
    useEffect(() => {
        let queryParams = ""
        if (!!searchParams.size && searchParams.get("page") && searchParams.get("page") !== "1") {
            queryParams = `?page=${searchParams.get("page")}`
        }
        dispatch(getMattersListReq(queryParams));
    }, [dispatch, searchParams]);

    const handleChangePage = (event, newPage) => {
        router.queryPush(newPage !== 0 ? { page: newPage + 1 } : {})
    };
    const handleClick = useCallback(async () => {
        const payloadOut = await dispatch(storeMatterReq());
        if (payloadOut.error?.message !== "Rejected") {
            router.push(`/matter/${payloadOut.payload.matter_id}?step=1`);
        }
    }, [dispatch, router]);

    return (
        <Container>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4">Matters</Typography>
                    <Button
                        onClick={handleClick}
                        variant="contained"
                        color="inherit"
                        startIcon={<Iconify icon="eva:plus-fill" />}
                    >
                        Add New Matter
                    </Button>
            </Stack>
            <Card sx={{ padding: "20px" }}>
                <TableContainer sx={{ overflow: 'unset' }}>
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow>
                                {[
                                    { id: 'name', label: 'Name' },
                                    { id: 'email', label: 'Email' },
                                    { id: 'phoneNumber', label: 'Phone number' },
                                    { id: 'employees', label: 'Employees' },
                                    { id: 'date', label: 'Date' },
                                    { id: '' },
                                ].map((headCell) => (
                                    <TableCell
                                        key={headCell.id}
                                        align={headCell.align || 'left'}
                                        sx={{ width: headCell.width, minWidth: headCell.minWidth }}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ pl: "20px" }}>
                            {mattersList?.map((
                                {
                                    id,
                                    personal_information: row,
                                    created_at,
                                    users: [{ name: employeeName }, ...others]
                                } = {}) => (
                                <UserTableRow
                                    key={id}
                                    name={row.name}
                                    email={row.email}
                                    date={created_at}
                                    phoneNumber={row.phone}
                                    role="admin"
                                    id={id}
                                    employees={{ employee: employeeName, length: others.length }}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    page={currentPage ? currentPage - 1 : 0}
                    component="div"
                    count={listLength || 0}
                    rowsPerPage={rowsPerPage || 8}
                    onPageChange={handleChangePage}
                    rowsPerPageOptions={[]}
                />
            </Card>
        </Container>
    );
}

export default MattersList;